// extracted by mini-css-extract-plugin
module.exports = {"list":"_10336","item":"_10693","goods":"_16338","info":"_14171","title":"_2066","price":"_9981","current":"_16044","origin":"_9316"};